"use client";

import { c as _c } from "react/compiler-runtime";
import { loadStripe } from "@stripe/stripe-js/pure";
import { useEffect, useState } from "react";
import type { Stripe } from "@stripe/stripe-js";
let stripePromise: Promise<Stripe | null> | null = null;
function getStripePromise() {
  stripePromise ??= loadStripe(process.env.NODE_ENV === "development" ? "pk_test_51RRXM1CYKGHizcWTfXxFSEzN8gsUQkg2efi2FN5KO2M2hxdV9QPCjeZMPaZQHSAatxpK9wDcSeilyYU14gz2qA2p00R4q5xU1R" : "pk_live_51RRXLsEAkKxa3kRayCPr9oW8dUp7mIzwev1FVpM3jpKU3StLaaiKvXCEPkewabL5hRip4IXLzFlFTLC4RpFWRknN00lX2vgZHP");
  return stripePromise;
}
export function useStripe() {
  const $ = _c(6);
  const [stripe, setStripe] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      getStripePromise().then(stripeInstance => {
        setStripe(stripeInstance);
        setIsLoading(false);
      }).catch(err => {
        setError(err);
        setIsLoading(false);
      });
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== error || $[3] !== isLoading || $[4] !== stripe) {
    t2 = {
      stripe,
      isLoading,
      error
    };
    $[2] = error;
    $[3] = isLoading;
    $[4] = stripe;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
export function loadStripeNow() {
  return getStripePromise();
}